import React from 'react';

const AparatIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g>
        <g>
          <path d="m14.316 5.481-1.825-.412a2.763 2.763 0 0 0-3.3 2.087L8.771 9a7.616 7.616 0 0 1 5.545-3.519z" transform="translate(-3.283 -.624)" fill={'#ffffff'}/>
          <path d="m5.481 26.119-.412 1.825a2.763 2.763 0 0 0 2.087 3.3l1.844.42a7.617 7.617 0 0 1-3.519-5.545z" transform="translate(-1.107 -12.81)" fill={'#ffffff'}/>
          <path d="m35.393 9.187-1.84-.416a7.616 7.616 0 0 1 3.515 5.545l.412-1.825a2.763 2.763 0 0 0-2.087-3.304z" transform="translate(-17.583 -2.8)" fill={'#ffffff'}/>
          <path d="m26.119 37.068 1.825.412a2.763 2.763 0 0 0 3.3-2.087l.416-1.84a7.616 7.616 0 0 1-5.541 3.515z" transform="translate(-13.294 -17.1)" fill={'#ffffff'}/>
        </g>
        <path data-name="Path 2778" d="M14.767 8a6.767 6.767 0 1 0 6.767 6.767A6.767 6.767 0 0 0 14.767 8zm-1.692 2.115a1.692 1.692 0 1 1-1.692 1.692 1.692 1.692 0 0 1 1.693-1.692zm-1.269 8.036a1.692 1.692 0 1 1 1.694-1.692 1.692 1.692 0 0 1-1.693 1.692zm2.115-3.384a.846.846 0 1 1 .846.827.846.846 0 0 1-.846-.827zm2.538 4.653a1.692 1.692 0 1 1 1.692-1.692 1.692 1.692 0 0 1-1.692 1.692zm1.269-4.653a1.692 1.692 0 1 1 1.692-1.692 1.692 1.692 0 0 1-1.692 1.692z" transform="translate(-2.838 -2.355)" fill={'#ffffff'}/>
      </g>
    </svg>
  );
};

export default AparatIcon;
